import {createContext, useContext} from "react";
const ThemeContext = /* @__PURE__ */ createContext(null);
function useTheme() {
  const theme = useContext(ThemeContext);
  return theme;
}
export {ThemeContext as T, useTheme as u};
